// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Floating Chat Button */
.floating-chat-button {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: #007bff;
  color: var(--color-white);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  transition: all 0.3s ease;
  display:none;
}

.floating-chat-button:hover {
  background: #0056b3;
  transform: scale(1.05);
}

.chat-badge {
  position: absolute;
  top: -5px;
  right: -5px;
  font-size: 10px;
}

/* Floating Chat Minimized */
.floating-chat-minimized {
  position: fixed;
  bottom: 20px;
  right: 20px;
  background: #007bff;
  color: var(--color-white);
  padding: 12px 20px;
  border-radius: 25px;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  display: flex;
  align-items: center;
  transition: all 0.3s ease;
  max-width: 300px;
}

.floating-chat-minimized:hover {
  background: #0056b3;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
}

/* Floating Chat Window */
.floating-chat-window {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 380px;
  height: 500px;
  z-index: 1000;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  overflow: hidden;
}

.floating-chat-window .card {
  height: 100%;
  display: flex;
  flex-direction: column;
  margin: 0;
}

.floating-chat-window .card-header {
  background: #007bff;
  color: var(--color-white);
  border-bottom: none;
  padding: 12px 16px;
  font-weight: 500;
}

.floating-chat-window .card-body {
  flex: 1 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* User List */
.chat-user-list {
  height: 100%;
  overflow-y: auto;
}

.chat-user-list .list-group-item {
  border-left: none;
  border-right: none;
  padding: 12px 16px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.chat-user-list .list-group-item:hover {
  background-color: var(--color-bg-hover);
}

.chat-user-list .list-group-item:first-child {
  border-top: none;
}

/* Chat Messages */
.chat-messages {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.messages-container {
  flex: 1 1;
  overflow-y: auto;
  padding: 16px;
  background: var(--color-bg-hover);
  scroll-behavior: smooth;
}

.message {
  display: flex;
  margin-bottom: 12px;
}

.message.sent {
  justify-content: flex-end;
}

.message.received {
  justify-content: flex-start;
}

.message-bubble {
  max-width: 70%;
  padding: 8px 12px;
  border-radius: 12px;
  word-wrap: break-word;
}

.message.sent .message-bubble {
  background: #007bff;
  color: var(--color-white);
  border-bottom-right-radius: 4px;
}

.message.received .message-bubble {
  background: var(--color-white);
  color: #333;
  border-bottom-left-radius: 4px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

/* Unread message styles */
.message.unread .message-bubble {
  background: #e8f4ff;
  border-left: 3px solid #007bff;
  box-shadow: 0 2px 4px rgba(0, 123, 255, 0.15);
  animation: pulse-unread 2s ease-in-out infinite;
}

@keyframes pulse-unread {
  0%, 100% {
    box-shadow: 0 2px 4px rgba(0, 123, 255, 0.15);
  }
  50% {
    box-shadow: 0 2px 8px rgba(0, 123, 255, 0.3);
  }
}

.unread-indicator {
  color: #007bff;
  font-size: 8px;
  margin-left: 6px;
  animation: blink 1.5s ease-in-out infinite;
}

@keyframes blink {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.3;
  }
}

.message-sender {
  font-size: 11px;
  font-weight: 600;
  margin-bottom: 4px;
  color: #666;
}

.message.sent .message-sender {
  color: rgba(255, 255, 255, 0.8);
}

.message-content {
  font-size: 14px;
  line-height: 1.4;
}

.message-time {
  font-size: 10px;
  margin-top: 4px;
  opacity: 0.7;
}

/* Reply Preview in Message Bubble */
.reply-preview {
  background: rgba(0, 0, 0, 0.1);
  border-left: 3px solid rgba(0, 123, 255, 0.5);
  padding: 6px 10px;
  margin-bottom: 8px;
  border-radius: 6px;
}

.message.sent .reply-preview {
  background: rgba(255, 255, 255, 0.2);
  border-left-color: rgba(255, 255, 255, 0.6);
}

.reply-preview .reply-sender {
  font-size: 11px;
  font-weight: 600;
  color: #007bff;
  margin-bottom: 2px;
}

.message.sent .reply-preview .reply-sender {
  color: rgba(255, 255, 255, 0.9);
}

.reply-preview .reply-content {
  font-size: 12px;
  color: #555;
  max-height: 40px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.message.sent .reply-preview .reply-content {
  color: rgba(255, 255, 255, 0.8);
}

/* Replying To Bar (above input) */
.replying-to-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: #f0f8ff;
  border-left: 3px solid #007bff;
  border-radius: 4px;
  margin-bottom: 8px;
}

.reply-to-sender {
  font-size: 11px;
  font-weight: 600;
  color: #007bff;
  margin-bottom: 2px;
}

.reply-to-content {
  font-size: 12px;
  color: #555;
  max-height: 40px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Message Input Form */
.message-input-form {
  padding: 12px;
  border-top: 1px solid #dee2e6;
  background: var(--color-white);
}

.message-input-form .form-control {
  border-radius: 20px;
}

.message-input-form .btn {
  border-radius: 50%;
  width: 40px;
  height: 40px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Scrollbar Styling */
.chat-user-list::-webkit-scrollbar,
.messages-container::-webkit-scrollbar {
  width: 6px;
}

.chat-user-list::-webkit-scrollbar-track,
.messages-container::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.chat-user-list::-webkit-scrollbar-thumb,
.messages-container::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 3px;
}

.chat-user-list::-webkit-scrollbar-thumb:hover,
.messages-container::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* Responsive */
@media (max-width: 576px) {
  .floating-chat-window {
    width: calc(100% - 40px);
    height: calc(100% - 40px);
    bottom: 10px;
    right: 10px;
  }
}
.chat-icon-green {
  color: var(--color-primary-green);
}

.chat-icon-orange {
  color: var(--color-primary-orange);
}`, "",{"version":3,"sources":["webpack://./src/containers/chat/components/FloatingChatWindow.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,0CAA0C;EAC1C,aAAa;EACb,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA,4BAA4B;AAC5B;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,0CAA0C;EAC1C,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,aAAa;EACb,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA,cAAc;AACd;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;EAC9B,WAAW;EACX,8BAA8B;EAC9B,wCAAwC;AAC1C;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,6CAA6C;EAC7C,+CAA+C;AACjD;;AAEA;EACE;IACE,6CAA6C;EAC/C;EACA;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,YAAY;AACd;;AAEA,oCAAoC;AACpC;EACE,8BAA8B;EAC9B,6CAA6C;EAC7C,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;AACjC;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,sBAAsB;AACtB;;EAEE,UAAU;AACZ;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE;IACE,wBAAwB;IACxB,yBAAyB;IACzB,YAAY;IACZ,WAAW;EACb;AACF;AACA;EACE,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;AACpC","sourcesContent":["/* Floating Chat Button */\r\n.floating-chat-button {\r\n  position: fixed;\r\n  bottom: 20px;\r\n  right: 20px;\r\n  width: 60px;\r\n  height: 60px;\r\n  border-radius: 50%;\r\n  background: #007bff;\r\n  color: var(--color-white);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\r\n  z-index: 1000;\r\n  transition: all 0.3s ease;\r\n  display:none;\r\n}\r\n\r\n.floating-chat-button:hover {\r\n  background: #0056b3;\r\n  transform: scale(1.05);\r\n}\r\n\r\n.chat-badge {\r\n  position: absolute;\r\n  top: -5px;\r\n  right: -5px;\r\n  font-size: 10px;\r\n}\r\n\r\n/* Floating Chat Minimized */\r\n.floating-chat-minimized {\r\n  position: fixed;\r\n  bottom: 20px;\r\n  right: 20px;\r\n  background: #007bff;\r\n  color: var(--color-white);\r\n  padding: 12px 20px;\r\n  border-radius: 25px;\r\n  cursor: pointer;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\r\n  z-index: 1000;\r\n  display: flex;\r\n  align-items: center;\r\n  transition: all 0.3s ease;\r\n  max-width: 300px;\r\n}\r\n\r\n.floating-chat-minimized:hover {\r\n  background: #0056b3;\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n/* Floating Chat Window */\r\n.floating-chat-window {\r\n  position: fixed;\r\n  bottom: 20px;\r\n  right: 20px;\r\n  width: 380px;\r\n  height: 500px;\r\n  z-index: 1000;\r\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);\r\n  border-radius: 8px;\r\n  overflow: hidden;\r\n}\r\n\r\n.floating-chat-window .card {\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  margin: 0;\r\n}\r\n\r\n.floating-chat-window .card-header {\r\n  background: #007bff;\r\n  color: var(--color-white);\r\n  border-bottom: none;\r\n  padding: 12px 16px;\r\n  font-weight: 500;\r\n}\r\n\r\n.floating-chat-window .card-body {\r\n  flex: 1;\r\n  overflow: hidden;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n/* User List */\r\n.chat-user-list {\r\n  height: 100%;\r\n  overflow-y: auto;\r\n}\r\n\r\n.chat-user-list .list-group-item {\r\n  border-left: none;\r\n  border-right: none;\r\n  padding: 12px 16px;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.chat-user-list .list-group-item:hover {\r\n  background-color: var(--color-bg-hover);\r\n}\r\n\r\n.chat-user-list .list-group-item:first-child {\r\n  border-top: none;\r\n}\r\n\r\n/* Chat Messages */\r\n.chat-messages {\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.messages-container {\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  padding: 16px;\r\n  background: var(--color-bg-hover);\r\n  scroll-behavior: smooth;\r\n}\r\n\r\n.message {\r\n  display: flex;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.message.sent {\r\n  justify-content: flex-end;\r\n}\r\n\r\n.message.received {\r\n  justify-content: flex-start;\r\n}\r\n\r\n.message-bubble {\r\n  max-width: 70%;\r\n  padding: 8px 12px;\r\n  border-radius: 12px;\r\n  word-wrap: break-word;\r\n}\r\n\r\n.message.sent .message-bubble {\r\n  background: #007bff;\r\n  color: var(--color-white);\r\n  border-bottom-right-radius: 4px;\r\n}\r\n\r\n.message.received .message-bubble {\r\n  background: var(--color-white);\r\n  color: #333;\r\n  border-bottom-left-radius: 4px;\r\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n/* Unread message styles */\r\n.message.unread .message-bubble {\r\n  background: #e8f4ff;\r\n  border-left: 3px solid #007bff;\r\n  box-shadow: 0 2px 4px rgba(0, 123, 255, 0.15);\r\n  animation: pulse-unread 2s ease-in-out infinite;\r\n}\r\n\r\n@keyframes pulse-unread {\r\n  0%, 100% {\r\n    box-shadow: 0 2px 4px rgba(0, 123, 255, 0.15);\r\n  }\r\n  50% {\r\n    box-shadow: 0 2px 8px rgba(0, 123, 255, 0.3);\r\n  }\r\n}\r\n\r\n.unread-indicator {\r\n  color: #007bff;\r\n  font-size: 8px;\r\n  margin-left: 6px;\r\n  animation: blink 1.5s ease-in-out infinite;\r\n}\r\n\r\n@keyframes blink {\r\n  0%, 100% {\r\n    opacity: 1;\r\n  }\r\n  50% {\r\n    opacity: 0.3;\r\n  }\r\n}\r\n\r\n.message-sender {\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  margin-bottom: 4px;\r\n  color: #666;\r\n}\r\n\r\n.message.sent .message-sender {\r\n  color: rgba(255, 255, 255, 0.8);\r\n}\r\n\r\n.message-content {\r\n  font-size: 14px;\r\n  line-height: 1.4;\r\n}\r\n\r\n.message-time {\r\n  font-size: 10px;\r\n  margin-top: 4px;\r\n  opacity: 0.7;\r\n}\r\n\r\n/* Reply Preview in Message Bubble */\r\n.reply-preview {\r\n  background: rgba(0, 0, 0, 0.1);\r\n  border-left: 3px solid rgba(0, 123, 255, 0.5);\r\n  padding: 6px 10px;\r\n  margin-bottom: 8px;\r\n  border-radius: 6px;\r\n}\r\n\r\n.message.sent .reply-preview {\r\n  background: rgba(255, 255, 255, 0.2);\r\n  border-left-color: rgba(255, 255, 255, 0.6);\r\n}\r\n\r\n.reply-preview .reply-sender {\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  color: #007bff;\r\n  margin-bottom: 2px;\r\n}\r\n\r\n.message.sent .reply-preview .reply-sender {\r\n  color: rgba(255, 255, 255, 0.9);\r\n}\r\n\r\n.reply-preview .reply-content {\r\n  font-size: 12px;\r\n  color: #555;\r\n  max-height: 40px;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.message.sent .reply-preview .reply-content {\r\n  color: rgba(255, 255, 255, 0.8);\r\n}\r\n\r\n/* Replying To Bar (above input) */\r\n.replying-to-bar {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 8px 12px;\r\n  background: #f0f8ff;\r\n  border-left: 3px solid #007bff;\r\n  border-radius: 4px;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.reply-to-sender {\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  color: #007bff;\r\n  margin-bottom: 2px;\r\n}\r\n\r\n.reply-to-content {\r\n  font-size: 12px;\r\n  color: #555;\r\n  max-height: 40px;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n/* Message Input Form */\r\n.message-input-form {\r\n  padding: 12px;\r\n  border-top: 1px solid #dee2e6;\r\n  background: var(--color-white);\r\n}\r\n\r\n.message-input-form .form-control {\r\n  border-radius: 20px;\r\n}\r\n\r\n.message-input-form .btn {\r\n  border-radius: 50%;\r\n  width: 40px;\r\n  height: 40px;\r\n  padding: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n/* Scrollbar Styling */\r\n.chat-user-list::-webkit-scrollbar,\r\n.messages-container::-webkit-scrollbar {\r\n  width: 6px;\r\n}\r\n\r\n.chat-user-list::-webkit-scrollbar-track,\r\n.messages-container::-webkit-scrollbar-track {\r\n  background: #f1f1f1;\r\n}\r\n\r\n.chat-user-list::-webkit-scrollbar-thumb,\r\n.messages-container::-webkit-scrollbar-thumb {\r\n  background: #888;\r\n  border-radius: 3px;\r\n}\r\n\r\n.chat-user-list::-webkit-scrollbar-thumb:hover,\r\n.messages-container::-webkit-scrollbar-thumb:hover {\r\n  background: #555;\r\n}\r\n\r\n/* Responsive */\r\n@media (max-width: 576px) {\r\n  .floating-chat-window {\r\n    width: calc(100% - 40px);\r\n    height: calc(100% - 40px);\r\n    bottom: 10px;\r\n    right: 10px;\r\n  }\r\n}\r\n.chat-icon-green {\r\n  color: var(--color-primary-green);\r\n}\r\n\r\n.chat-icon-orange {\r\n  color: var(--color-primary-orange);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
